/**
 * Provides JS functionality for tracking alert display.
 */
class RelatedServices extends DrupalBehavior {
  onContent(context) {
    $('.paragraph--type--related-services').each((k, item) => {
      const element = $(item);
      const links = element.find('ul li');
      const buttonWrapper = $('<div></div>').addClass('btn-wrapper');
      const button = $('<a></a>').addClass('btn-underline btn-underline--yellow').text('View more');
      button.on('click', (event) => {
        event.preventDefault();
        if (!element.hasClass('show-all')) {
          element.addClass('show-all');
          button.html('View less');
        } else {
          element.removeClass('show-all');
          button.html('View more');
        }
      });

      if (links.length > 10 && !element.find('.btn-wrapper').length) {
        buttonWrapper.appendTo(element.find('.wrapper'));
        button.appendTo(buttonWrapper);
      }
    });
  }

}

DrupalBehavior.register('camc.components', 'related_services', RelatedServices);
